import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    name: 'impersonate-popup',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class ImpersondatePopup extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    @Prop()
    private accessToken: any;

    // ------------------------------------------------------------------------
    // Actions
    private impersonateAccount() {
        const apiEndpoint = appConfigService.getApiUrl();
        if (this.$parent) {
            this.$parent.$data.isShowPopup = false;
        }
        window.open(`${apiEndpoint}?access_token=${this.accessToken}`);
        // this.$router.push(this.$access.landingPage);
        // window.location.reload();
    }
}
